"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = exports.useBaseStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../../utils");
exports.useBaseStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        base: {
            '& .MuiTab-labelIcon': {
                minHeight: 'unset',
            },
        },
        indicator: function (_a) {
            var errors = _a.errors;
            return ({
                backgroundColor: !errors ? theme.palette.primary.dark : theme.palette.error.main,
            });
        },
    });
});
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        base: {
            '& .MuiTab-labelIcon': {
                minHeight: 'unset',
            },
        },
        root: function (_a) {
            var errors = _a.errors;
            return ({
                color: !errors ? theme.palette.primary.main : theme.palette.error.main,
                fontWeight: utils_1.textWeightMap.bold,
                opacity: 1,
                '&::after': {
                    content: "'".concat(errors, "'"),
                    display: !errors ? 'none' : 'auto',
                    width: 18,
                    height: 16,
                    fontSize: 9,
                    fontWeight: 'bold',
                    lineHeight: '1.8',
                    backgroundColor: theme.palette.error.main,
                    borderRadius: '50%',
                    color: theme.palette.primary.contrastText,
                },
            });
        },
        indicator: function (_a) {
            var errors = _a.errors;
            return ({
                backgroundColor: !errors ? theme.palette.primary.dark : theme.palette.error.main,
            });
        },
        selected: function (_a) {
            var errors = _a.errors;
            return ({
                color: !errors ? theme.palette.primary.dark : theme.palette.error.main,
                backgroundColor: !errors ? theme.palette.background.default : theme.palette.error.light,
                fontWeight: utils_1.textWeightMap.bold,
                '&::after': {
                    content: "'".concat(errors, "'"),
                    display: !errors ? 'none' : 'auto',
                    width: 18,
                    height: 16,
                    fontSize: 9,
                    fontWeight: 'bold',
                    lineHeight: '1.8',
                    backgroundColor: theme.palette.error.main,
                    borderRadius: '50%',
                    color: theme.palette.primary.contrastText,
                },
            });
        },
    });
});
